import './index.css'


// WEBPACK FOOTER //
// ./ecology9/base/wea-new-table/style/index.js